import PropTypes from 'prop-types';
import { appRoutesPropTypes } from '../route/route-prop-types';
import appStatesPropTypes from '../state/state-prop-types';
import themePropTypes from '../theme/theme-prop-types';

const appConfigPropTypes = PropTypes.shape({
  // internationalization.
  intlDefaultLocale: PropTypes.string,
  intlSupportedLocales: PropTypes.arrayOf(PropTypes.string),
  intlMessageLocales: PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)),
  intlMessageSeedLocales: PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)),
  intlExtraMessageLocales: PropTypes.objectOf(
    PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  ),

  // theme
  themeDefaultTheme: PropTypes.string,
  themeSupportedThemes: PropTypes.arrayOf(PropTypes.string),
  themeThemes: PropTypes.objectOf(themePropTypes),

  // Font
  fontDefaultFont: PropTypes.string,
  fontSupportedFonts: PropTypes.arrayOf(PropTypes.string),
  fontDefaultFontSize: PropTypes.number,
  fontSupportedFontSizes: PropTypes.arrayOf(PropTypes.number),

  // state
  stateAppStates: PropTypes.objectOf(appStatesPropTypes),
  stateDefaultAppStates: PropTypes.objectOf(PropTypes.any),

  // Route
  appRoutes: PropTypes.arrayOf(appRoutesPropTypes),
  AuthenticationRepository: PropTypes.any,
  notFoundPage: PropTypes.node,
  loadingPage: PropTypes.node,
  applicationName: PropTypes.string,
  commonComponentProps: PropTypes.objectOf(PropTypes.any),
  icons: PropTypes.objectOf(PropTypes.object),

  // Firebase
  firebaseConfig: PropTypes.shape({
    apiKey: PropTypes.string.isRequired,
    authDomain: PropTypes.string.isRequired,
    databaseURL: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    storageBucket: PropTypes.string.isRequired,
    messagingSenderId: PropTypes.string.isRequired,
    appId: PropTypes.string.isRequired,
    firebaseOptions: PropTypes.objectOf(PropTypes.any),
  }),
});

export default appConfigPropTypes;
